import { Route, Routes } from "react-router-dom";
import Login from "./Dashboard/Auth/Login";
import RequireAuth from "./Dashboard/Auth/RequireAuth";
import RequireBack from "./Dashboard/Auth/RequireBack";
import NotFound from "./Dashboard/NotFound/NotFound";
import NewSection from "./Dashboard/NewSection/Targets";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route element={<RequireBack />}>
          <Route path="/" element={<Login />} />
        </Route>
        <Route element={<RequireAuth />}>
          <Route path="/targets" element={<NewSection />}>
          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
